import React from "react";
import {
  SubTitleTab,
  TitleTab,
} from "../../../../../../component/page-components";
import { Col, DatePicker, Input, Row } from "antd";
import { getNameImage, licenseType } from "../../../../../../util/Util";
import { ProfileKosong } from "../../../../../../asset";
import moment from "moment";
import MSSDisplaySkillset from "../../../../../../component/mss/skillset/display-skillset";

const FleetDetailOwned = ({ form }) => {
  return (
      <div className="columns">
        <TitleTab title="Fleet Detail" />

        <div className="container-field">
          <SubTitleTab title="Driver License Photo (Optional)" />
          <div className="bg-gray-1000 border-dashed border-2 border-sky-500 p-5 rounded-md">
            <div className="border-solid border-2 border-sky-500 w-full p-4 rounded-md">
              <Row>
                <Col span={6}>
                  <img
                    className="h-30 w-48 py-2"
                    src={
                      form?.license_image ? form?.license_image : ProfileKosong
                    }
                    alt="driver_photo"
                  />
                </Col>
                <Col
                  span={18}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    position: "relative",
                  }}
                >
                  <p className=" absolute top-[45%]">
                    {form?.license_image
                      ? getNameImage(form?.license_image)
                      : "tidak ada foto"}
                  </p>
                </Col>
              </Row>
            </div>
          </div>
        </div>

        <div className="container-field">
          <SubTitleTab title="License Type" />
          <Input
            size="large"
            value={form?.license_type ? licenseType(form?.license_type) : "-"}
            disabled
          />
        </div>

        <div className="container-field">
          <SubTitleTab title="License ID" />
          <Input
            size="large"
            value={form?.license_id ? form?.license_id : "-"}
            disabled
          />
        </div>

        <div className="container-field">
          <SubTitleTab title="License Number" />
          <Input
            size="large"
            value={
              form?.driving_license_number ? form?.driving_license_number : "-"
            }
            disabled
          />
        </div>

        <div className="container-field">
          <SubTitleTab title="Validity Period of Driving License" />
          <DatePicker
            style={{ width: "50%" }}
            size="large"
            format="DD MMMM YYYY"
            value={
              form?.validity_period_driving_license &&
              form?.validity_period_driving_license !== "0001-01-01"
                ? moment(form?.validity_period_driving_license)
                : null
            }
            disabled
          />
        </div>

        <div className="container-field">
          <SubTitleTab title="Vehicle Type (Optional)" />
          <Input
            size="large"
            value={form?.vehicle_type ? form?.vehicle_type : "-"}
            disabled
          />
        </div>

        <div className="container-field">
          <SubTitleTab title="Vehicle Model (Optional)" />
          <Input
            size="large"
            value={form?.vehicle_model ? form?.vehicle_model : "-"}
            disabled
          />
        </div>

        <div className="container-field">
          <SubTitleTab title="Vehicle No" />
          <Input
            size="large"
            value={form?.vehicle_plate ? form?.vehicle_plate : "-"}
            disabled
          />
        </div>

        <div className="container-field">
          <SubTitleTab title="Temperature Category" />
          <Input
            size="large"
            value={form?.temperature_category ? form?.temperature_category : "-"}
            disabled
          />
        </div>

        <div className="container-field">
          <SubTitleTab title="Skill Set" />
          <MSSDisplaySkillset listSkillset={form?.skill_set} disabled />
        </div>
        
      <div className="container-field">
        <SubTitleTab title="Total Range Distance" />
        <Input
          addonAfter="Km"
          size="large"
          value={form?.total_range_distance}
          disabled
        />
      </div>
      </div>
  );
};

export default FleetDetailOwned;
